import { useEffect, useState, useContext } from "react";
import { PortalContext } from "../../../context/Provider";
import { showToaster } from "../../../../global/context/action/toaster/toaster.js";
import {
  resetPaciente,
  wsPostActualizarClave,
} from "../../../context/Actions/paciente/paciente";
import { regexNumero } from "../../../../global/utils/expresionesRegulares";
import { setUsuario } from "../../../context/Actions/registro/registro";
import sliceInput from "../../../../global/utils/sliceInput";
import HidePassIcon from "../../../assets/images/generico/HidePassIcon";
import ShowPassIcon from "../../../assets/images/generico/ShowPassIcon";
import "./CambioPassword.css";
import { GlobalContext } from "../../../../global/context/Provider";
import InputV1 from "../../Genericos/InputV1/InputV1";

// Agregado: teclado alfanumérico (solo tablet/desktop)
import styled from "styled-components";
import TecladoAlfanumerico from "_+_Portal/components/Genericos/TecladoAlfanumerico/TecladoAlfanumerico";

const TecladoWrapper = styled.div`
  width: 100%;
  padding: 20px 0;
  background-color: var(--color-latex10);
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const TecladoInner = styled.div`
  width: 1040px;
  max-width: 95vw;
  overflow: visible;
`;

const CambioPasswordPaso3 = ({ titulo, dissmiss, texto, token }) => {
  const { pacienteDispatch, pacienteState, registroState, registroDispatch } =
    useContext(PortalContext);

  // Toaster en global
  const { toasterDispatch } = useContext(GlobalContext);

  const [nuevoPassword, setNuevoPassword] = useState("");
  const [repitoPassword, setRepitoPassword] = useState("");
  const [nuevoPasswordError, setNuevoPasswordError] = useState(false);
  const [repitoPasswordError, setRepitoPasswordError] = useState(false);
  const [passwordShown, setPasswordShown] = useState(false);
  const [passwordShownRepeat, setPasswordShownRepeat] = useState(false);
  const [codigoPaciente, setCodigoPaciente] = useState(
    pacienteState?.paciente?.data?.idPaciente
  );

  // Buffers locales y estado de teclado para sincronizar inputs con teclado alfanumérico
  const [kbdNuevo, setKbdNuevo] = useState("");
  const [kbdRepito, setKbdRepito] = useState("");
  const [kbdValue, setKbdValue] = useState("");
  const [kbdBaseline, setKbdBaseline] = useState("");
  const [baselineFor, setBaselineFor] = useState("txtNuevoPassword");
  const [lastActiveName, setLastActiveName] = useState("txtNuevoPassword");

  // Mostrar teclado solo en tablet/desktop y trackear foco del input activo
  const [isTabletOrDesktop, setIsTabletOrDesktop] = useState(
    typeof window !== "undefined" ? window.innerWidth >= 768 : true
  );
  useEffect(() => {
    const onResize = () => setIsTabletOrDesktop(window.innerWidth >= 768);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);
  const [activeInputName, setActiveInputName] = useState("txtNuevoPassword");
  useEffect(() => {
    const onFocusIn = (e) => {
      const t = e.target;
      if (t && t.tagName === "INPUT" && t.name) {
        setActiveInputName(t.name);
        // Al cambiar de foco, fijar baseline al valor acumulado actual del teclado
        setKbdBaseline(kbdValue);
        setBaselineFor(t.name);
      }
    };
    document.addEventListener("focusin", onFocusIn);
    return () => document.removeEventListener("focusin", onFocusIn);
  }, [kbdValue]);

  const onPasswordPress = (e) => {
    if (!regexNumero.test(e.key)) {
      e.preventDefault();
    }
    if (e.target.name === "txtNuevoPassword") {
      if (e.key === "Enter") {
        document.getElementsByName("txtRepitoPassword")[0].focus();
      }
    }
  };

  const showPassword = () => {
    setPasswordShown(true);
  };
  const hidePassword = () => {
    setPasswordShown(false);
  };

  const showPasswordRepeat = () => {
    setPasswordShownRepeat(true);
  };
  const hidePasswordRepeat = () => {
    setPasswordShownRepeat(false);
  };

  const isPasswordValido = (password) => {
    if (password === "") {
      return true;
    }
    return false;
  };

  const onNuevoPasswordChange = (e) => {
    sliceInput(e);
    setNuevoPasswordError(isPasswordValido(e.target.value));
    setNuevoPassword(e.target.value);
    // Sincroniza buffer teclado con valor del input
    const v = (e?.target?.value || "").replace(/[^0-9]/g, "").slice(0, 10);
    setKbdNuevo(v);
  };

  const onRepitoPasswordChange = (e) => {
    sliceInput(e);
    setRepitoPasswordError(isPasswordValido(e.target.value));
    setRepitoPassword(e.target.value);
    // Sincroniza buffer teclado con valor del input
    const v = (e?.target?.value || "").replace(/[^0-9]/g, "").slice(0, 10);
    setKbdRepito(v);
  };

  const confirmarPassword = () => {
    if (nuevoPassword.length >= 4 || repitoPassword.length >= 4) {
      if (
        nuevoPassword === repitoPassword &&
        nuevoPassword !== "" &&
        repitoPassword !== ""
      ) {
        wsPostActualizarClave(
          nuevoPassword,
          repitoPassword,
          codigoPaciente,
          token
        )(pacienteDispatch);

        // MODIFICAR ESTA LOGICA ESTA MALLLLLLL
        let usuario = Object.assign({}, registroState.registro.usuario);
        usuario.telefono = repitoPassword;
        setUsuario(usuario)(registroDispatch);
      } else {
        showToaster(
          {
            texto:
              "Las contraseñas no coinciden, ingresá los campos solicitados.",
            tipo: "danger",
          },
          "centroArriba"
        )(toasterDispatch);
      }
    } else {
      showToaster(
        {
          texto: "La contraseña debe tener al menos 4 caracteres numéricos",
          tipo: "danger",
        },
        "centroArriba"
      )(toasterDispatch);
    }
  };

  useEffect(() => {
    document.getElementsByName("txtNuevoPassword")[0].focus();
  }, []);

  useEffect(() => {
    if (
      pacienteState.paciente.error !== null &&
      pacienteState.paciente.error !== undefined &&
      pacienteState.paciente.error.origen === "cambioClave" &&
      pacienteState.paciente.error !== false
    ) {
      if (
        pacienteState.paciente.error.status !== null &&
        pacienteState.paciente.error.status !== undefined &&
        pacienteState.paciente.error.origen === "cambioClave"
      ) {
        if (
          pacienteState.paciente.error.texto !== undefined &&
          pacienteState.paciente.error.texto !== null &&
          pacienteState.paciente.error.texto !== ""
        ) {
          showToaster(
            {
              texto: pacienteState.paciente.error.texto,
              tipo: "danger",
            },
            "centroArriba"
          )(toasterDispatch);
          resetPaciente()(pacienteDispatch);
        } else {
          showToaster(
            {
              texto: "La contraseña es incorrecta",
              tipo: "danger",
            },
            "centroArriba"
          )(toasterDispatch);
          resetPaciente()(pacienteDispatch);
        }
      }
    }
    //eslint-disable-next-line
  }, [pacienteState.paciente.error]);

  // Helpers teclado
  const sanitizeNumeric = (v) => (v || "").replace(/[^0-9]/g, "");
  const clampLen = (v, max = 10) => (v.length > max ? v.slice(0, max) : v);

  // Maneja cambio global del teclado virtual: solo sincroniza buffer/baseline (no escribe)
  const handleKeyboardChange = (value) => {
    if (typeof value !== "string") return;
    const globalNext = sanitizeNumeric(value);
    setKbdValue(globalNext);

    // Actualiza baseline y referencia para evitar duplicaciones en siguientes teclas
    setKbdBaseline(globalNext);
    setBaselineFor(activeInputName);
    setLastActiveName(activeInputName);
  };

  // Maneja borrado desde teclado virtual
  const handleKeyboardDelete = () => {
    if (activeInputName === "txtRepitoPassword") {
      const next = kbdRepito.slice(0, -1);
      setKbdRepito(next);
      onRepitoPasswordChange({ target: { value: next } });
    } else {
      const next = kbdNuevo.slice(0, -1);
      setKbdNuevo(next);
      onNuevoPasswordChange({ target: { value: next } });
    }
  };

  // Maneja cada tecla literal del teclado virtual para inputs type number
  const handleKeyboardKey = (button) => {
    const char = (button || "").toString();
    if (!/^[0-9]$/.test(char)) return; // solo números
    if (activeInputName === "txtRepitoPassword") {
      const next = clampLen(kbdRepito + char);
      setKbdRepito(next);
      onRepitoPasswordChange({ target: { value: next } });
    } else {
      const next = clampLen(kbdNuevo + char);
      setKbdNuevo(next);
      onNuevoPasswordChange({ target: { value: next } });
    }
  };

  // Enter del teclado confirma
  const handleKeyboardEnter = () => {
    confirmarPassword();
  };

  return (
    <>
      <div className="ptur-modal-password modalHeader bgcG-latex30">
        <h1 className="modalTitle rb18b c-white">
          {titulo === "" ? "Error en el sistema" : titulo}
        </h1>
        <div className="cruz" onClick={dissmiss}>
          <div className="cruzParte1"></div>
          <div className="cruzParte2"></div>
        </div>
      </div>
      <div className="modalBody">
        <h3 className="ptur-modal-texto rb16m c-latex10">
          La contraseña debe contener solo valores numéricos
        </h3>
        <h3 className="rb16t c-latex10">{texto === "" ? "" : texto}</h3>
        <div className="ptur-modal-input">
          <InputV1
            headerStr="Nueva contraseña"
            placeholderText="23756"
            inputType="number"
            name="txtNuevoPassword"
            errorStr="La contraseña es inválida."
            onChange={onNuevoPasswordChange}
            onKeyPress={onPasswordPress}
            value={nuevoPassword}
            className={
              passwordShown
                ? "inputNumericShow inputNonScroll rb16m"
                : "inputNumeric inputNonScroll rb16m"
            }
            maxLength="10"
            checkError={nuevoPasswordError}
            isRequired={true}
            pattern={"[0-9]*"}
            inputMode={"numeric"}
          />
          {passwordShown === false ? (
            <>
              <button
                className="ptur-modal-password-show-hideBtn"
                onClick={() => showPassword()}
              >
                <HidePassIcon color="var(--color-latex30)" />
              </button>
            </>
          ) : (
            <>
              <button
                className="ptur-modal-password-show-hideBtn"
                onClick={() => hidePassword()}
              >
                <ShowPassIcon color="var(--color-latex30)" />
              </button>
            </>
          )}
        </div>
        <div className="ptur-modal-input">
          <InputV1
            headerStr="Repita la nueva contraseña"
            placeholderText="23756"
            inputType="number"
            name="txtRepitoPassword"
            errorStr="La contraseña es inválida."
            onChange={onRepitoPasswordChange}
            onKeyPress={onPasswordPress}
            value={repitoPassword}
            className={
              passwordShownRepeat
                ? "inputNumericShow inputNonScroll rb16m"
                : "inputNumeric inputNonScroll rb16m"
            }
            maxLength="10"
            checkError={repitoPasswordError}
            isRequired={true}
            pattern={"[0-9]*"}
            inputMode={"numeric"}
          />
          {passwordShownRepeat === false ? (
            <>
              <button
                className="ptur-modal-password-show-hideBtn"
                onClick={() => showPasswordRepeat()}
              >
                <HidePassIcon color="var(--color-latex30)" />
              </button>
            </>
          ) : (
            <>
              <button
                className="ptur-modal-password-show-hideBtn"
                onClick={() => hidePasswordRepeat()}
              >
                <ShowPassIcon color="var(--color-latex30)" />
              </button>
            </>
          )}
        </div>
        <button
          className="btnCambioPassword enviar rb18m"
          onClick={() => confirmarPassword()}
        >
          Confirmar y actualizar
        </button>
      </div>
      {isTabletOrDesktop && (
        <TecladoWrapper>
          <TecladoInner>
            <TecladoAlfanumerico
              sinNumeros={false}
              modeLight={true}
              onEnter={handleKeyboardEnter}
              enterStr={"Enter"}
              onChange={handleKeyboardChange}
              maxLength={20}
              onDelete={handleKeyboardDelete}
              onKey={handleKeyboardKey}
            />
          </TecladoInner>
        </TecladoWrapper>
      )}
    </>
  );
};

export default CambioPasswordPaso3;
